import { gql } from '@apollo/client';

export const GET_APPLICATION = gql`
  query GetApplication($id: String!) {
    application(id: $id) {
      _id
      interview {
        _id
        transcripts
      }
    }
  }
`;

export default GET_APPLICATION;
